import React from 'react'

const index = (props) => {
  window.location.replace('/login')
  return <div>...</div>
}

export default index
